export default __webpack_public_path__ + "static/media/AMS - download-not_Dark2.db53ebab.svg";